module.exports = __webpack_public_path__ + "079c8235f39bc3e9534a837a40b3eb8e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/logo/logotext.svg
// module id = 25
// module chunks = 0